import type { ReactNode } from 'react'

interface HeaderCardProps {
  title: string
  value: ReactNode
  variant?: 'default' | 'status'
}

export const HeaderCard = ({ title, value, variant = 'default' }: HeaderCardProps) => {
  const isStatus = variant === 'status'

  return (
    <div className="bg-slate-800 rounded-xl p-4 md:p-6 h-full flex flex-col justify-between shadow-md border border-slate-700">
      <div className="text-sm text-slate-400 font-medium mb-2">{title}</div>
      <div className={isStatus ? 'text-teal-400 font-bold text-lg' : 'text-white font-semibold text-xl'}>
        {value}
      </div>
    </div>
  )
}
